import { FormActions } from "../../components/common/FormActions";
import { createViewAction, formatDateTime, NoWrap } from "../../utils/helpers";
import { URL_OUTGOING_REQUESTS } from "../../utils/urls";

export const useOutgoingRequests = () => {
  const tableColumns = () => [
    {
      id: "Method",
      header: "Method",
      filter: {
        type: "text",
      },
    },

    {
      id: "ExternalSystem",
      header: "External System",
      filter: {
        type: "text",
      },
    },
    {
      id: "StatusCode",
      header: "Status Code",
    },
    {
      id: "ResponseTimeMs",
      header: "Response Time (ms)",
    },
    {
      id: "TransactionId",
      header: "Transaction Id",
    },
    {
      id: "Reference",
      header: "Reference",
    },
    {
      id: "CreatedAt",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      const row = {
        ...item,
        Url: <NoWrap>{item?.Url}</NoWrap>,
        StatusCode: (
          <span
            style={{
              color: item?.StatusCode === 200 ? "#16a34a" : "#FF0000",
              fontWeight: "bold",
            }}
          >
            {item?.StatusCode}
          </span>
        ),
        CreatedAt: formatDateTime(item?.CreatedAt),
        actions: (
          <FormActions
            actions={[createViewAction(URL_OUTGOING_REQUESTS, item?.Id)]}
          />
        ),
      };
      return row;
    }),
  ];
  const externalFilters = [];

  const tableTotals = () => {
    return {};
  };

  const viewData = (item: any) => {
    return {
      Id: item?.id,
      RequestPayload: item?.requestPayload,
      ResponsePayload: item?.responsePayload,
      Method: item?.method,
      Url: item?.url,
      StatusCode: item?.statusCode,
      ExternalSystem: item?.externalSystem,
      ResponseTimeMs: item?.responseTimeMs,
      TransactionId: item?.transactionId,
      Reference: item?.reference,
      CreatedAt: formatDateTime(item?.createdAt),
    };
  };

  return {
    tableColumns,
    tableData,
    viewData,
    tableTotals,
    externalFilters,
  };
};
